import React, { Component } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import HeaderSample from "../common/headerSample";
import { _axios } from '../../plugins/axios';
import { URL,USER } from "../../constants/constant";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Select from "react-select";
import ReactDatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { Modal } from "react-bootstrap";

class CancelRescheduleRaiseAlertComponent extends Component{
  constructor(props){
    super(props);
    console.log(this.props);
    this.state = {
        userdata : USER.user,
        orderStatus : null,
        orderDetails : null,
        cameraToggle :  false,
        sampleCollection: null,
        orderId: this.props.match.params.orderId,
        orderDetails : USER.orderDetails,
        cancelForm : {
           // request : '',
            remarks : ''
        },
        options: [],
        reason: null,
        date: null,
        comment: null,
        isLoaded: false,
        relatedOrders: [],
        showBulkModal: false
    }

    this.getOptions = this.getOptions.bind(this);
    this.switchReason = this.switchReason.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
  }

  handleChange(event){
    // event.preventDefault();

    if (event.target.value && event.target.value.trim().length !== 0 ) {
        this.setState({
            comment: event.target.value
        });

    } else {
        this.setState({
            comment: null
        });
    }

 }
 
 switchReason(reason){

    console.log(reason);

    if  (!reason.value.includes("Reschedule") && !reason.value.includes("reschedule" ) && reason.value !== "Other") {
        this.setState({
            comment: reason.value,
            reason: reason.value
        });
    } else {
        this.setState({
            comment: null,
            reason: reason.value
        });
    }

 }



 componentDidMount () {

    this.getOptions();
    this.getOrders();

 }

getOptions () {

    const that = this;


    _axios.get(URL.dev_url + 'getAllRejectionReasons',{params:{visibleInRetool:0,visibleInRunnrApp:1}}).then(function (res) {

        console.log("res", res);
        
        let array = [...res.data.reasons];
        let options = [];

        console.log(res);


        res.data.reasons.forEach(i => {
            let obj = {
                value: "",
                label: "",
            };

            obj.value = i.reason;
            obj.label = i.reason;

            options.push(obj);
            
        });

        that.setState({
            options: options,
        }, () => console.log("state" , that.state));

    });
 

 }

 async getOrders(){
    try {
      let currOrderId = parseInt(this.props.match.params.orderId)
      let url = URL.dev_url;
      let route = url + 'getorders'
      let obj = {
          phleboId: this.state.userdata.phleboId,
      }
      const response = await _axios.post(route, obj)
      const currentOrder = response.data.pendingOrders.filter(data => data.orderId == currOrderId)
      let dependantId = currentOrder[0].dependantId
      let relatedOrders = response.data.pendingOrders.filter(data => data.dependantId == dependantId)
      relatedOrders = relatedOrders.map(data =>{
        data.isSelected = true
        return data
      })
      this.setState({ relatedOrders: relatedOrders, isLoaded: true })
    } catch (error) {
      console.log(error)
    }
  }

setStartDate(date) {

    console.log(date);
    var string = this.state.reason;
    var string2 = string.concat(" ");
    const newDate = date.toLocaleString();

    var string3= string2.concat(newDate);
    
    this.setState({
        date: date
    });

    this.setState({
        comment: string3
    });
    console.log(string3);

}

 raiseAlert(){
    console.log(this.state)
    if(this.state.relatedOrders.length > 1){
        this.setState({showBulkModal : true})
    } else {
        const that = this;
        let url = URL.dev_url;
         let route = url + 'updateorders'
         let obj = {
            access_token : "trialTest" || USER.access_token,
            currentStatusId : 3,
            requestNextStatusId : 31,
            phleboId: this.state.userdata.phleboId,
            orderId: parseInt(this.props.match.params.orderId),
            rescheduleComment : this.state.comment,
         }
    
        _axios.post(route,obj)
        .then(function (response) {
            if(response.data.success){
                let x =  '/orders'
                that.props.history.push(x);
            }
        }).catch(function (error) {
            console.log(error);
        })
    }
 }

 markBulkRaiseAlertupdate(id,e){
    const relatedOrders = this.state.relatedOrders
    for(let data of relatedOrders){
        if(data.orderId == id){
            data.isSelected = !data.isSelected
            break
        }
    }
    this.setState({ relatedOrders: relatedOrders })
  }

 async bulkRaiseAlert(id, e){
    try {
        let url = URL.dev_url;
        let route = url + 'updateorders'
        for(let order of this.state.relatedOrders){
            if(!order.isSelected) continue
             let obj = {
                access_token : "trialTest" || USER.access_token,
                currentStatusId : 3,
                requestNextStatusId : 31,
                phleboId: this.state.userdata.phleboId,
                orderId: order.orderId,
                rescheduleComment : this.state.comment,
             }
        
            let response = await _axios.post(route,obj)
            if(!response.data.success){
                throw new Error('Something went wrong!!!')
            }
        }
        this.props.history.push('/orders');
    } catch (error) {
        console.log(error)
    }
 }


  render(){
      console.log(this);

    return(
        this.state.isLoaded ? <div className="order-details-dashboard p-b-10">
                <div>
                   <HeaderSample  titleCall={true} title="Choose A Rejection Reason"></HeaderSample> 
                </div>
                <Modal
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.showBulkModal}
                    onHide={() => {this.setState({showBulkModal : false})}}
                    >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Update other tests as well for this customer ({this.state.relatedOrders?.[0]?.patientDetails?.[0]?.name})?
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{padding:'1px', overflowY: "auto",display: "flex", flexDirection: "column", rowGap: "1px", marginTop: "5px"}}>
                        <Row style={{"display": "flex", "flexDirection": "column", "marginLeft": "20px"}}>
                            {this.state.relatedOrders.map(data => (
                                 data.orderId != parseInt(this.props.match.params.orderId) && <div style={{display: "flex"}}>
                                    <input
                                        type="checkbox"
                                        id={data.id}
                                        name={data.id}
                                        onChange={(e) => this.markBulkRaiseAlertupdate(data.orderId, e)}
                                        checked={data.isSelected}
                                    />
                                    <label style={{marginLeft: "5px"}} for={data.id}>{`${data.tests[0].testName} (# ${data.appointmentId})`}</label>
                                </div> 
                                
                            ))}
                        </Row>
                            
                        
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => this.bulkRaiseAlert()}>Save changes</Button>
                    </Modal.Footer>
                </Modal>
                <div>
                    <Container className="p-t-10 p-b-10">
                        <Row>
                            <Col xs={6} md={6}>
                                <div className="text-align-center font-size-sm">
                                    Order Id
                                </div>
                                <div className="text-align-center  font-size-smd bold">
                                    {this.state.orderId}
                                </div>
                            </Col>
                            <Col xs={6} md={6}>
                                <div className="text-align-center  font-size-sm">
                                    Name
                                </div>
                                <div className="text-align-center  font-size-smd bold">
                                    {this.state.orderDetails ? this.state.orderDetails.pendingOrders[0].patientDetails[0].name : ''}
                                </div>
                            </Col>
                        </Row>

                    </Container>
                </div>

                <div>
                    <div>
                        {
                        <Form onSubmit={(e)=>this.handleSubmit(e)} className="p-20">
                                <Row className="p-t-10"  >
                                    <Col xs={12}>
                                    <div className="font-size-ml bold">Reason: </div>
                                    <Select  
                                    defaultValue={null}
                                    isSearchable = {true}
                                    style={{width: '100px'}}
                                    onChange={(event) => this.switchReason(event)}
                                    options={this.state.options} />
                                    </Col>

                                </Row>

                                {this.state.reason === "Other" &&
                                <Row className="p-t-10">
                                    <Col xs={12} md={12}>
                                            <Form.Control as="textarea"  size="sm" rows={3} name="remarks" onChange={(e)=>this.handleChange(e)} placeholder='Remarks' />
                                        </Col>
                                </Row>}

                                { this.state.reason !== null && (this.state.reason.includes("Reschedule") || this.state.reason.includes("reschedule")) &&
                                <Row className="date-picker p-t-10 m-1" >

                                    <div className="font-size-ml bold">Pick A Date and Time:</div>
                                    <ReactDatePicker
                                    selected={this.state.date} 
                                    onChange={date => this.setStartDate(date)} 
                                    showTimeSelect
                                    inputProps={{readOnly: true}}
                                    dateFormat="dd/MM/yyyy HH:mm"
                                    className="form-control"/>
                                </Row>}
                        </Form>

                         }
                    </div>
                </div>
                <Container>
                    <div className="fixed-bottom p-l-15 p-r-15 p-t-5">
                      <Row>
                          
                             <Col xs={6} ><div >
                                 <button type="button" className="btn btn-outline-primary width-100 border-curve-10" onClick={this.props.history.goBack}>Back</button>
                              </div>
                            </Col>
                            <Col xs={6}>
                            <Button variant="primary" size="md" block className="border-curve-10" disabled={this.state.comment === null} onClick={()=> this.raiseAlert()}>
                                Reject
                            </Button>
                            </Col>
                            
                          
                      </Row>
                    </div>
                  </Container>
             </div> : <>Loading...</>

    )
    }
}
export default CancelRescheduleRaiseAlertComponent;